import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST ITEM',
    dataIndex: 'reqItemId',
    key: 'reqItemId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'DEPT/PROJECT',
    dataIndex: 'deptProject',
    key: 'deptProject',
    ellipsis: true,
  },
  {
    title: 'EMPLOYEE NO.',
    dataIndex: 'empNo',
    key: 'empNumber',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMPLOYEE NAME',
    dataIndex: 'empName',
    key: 'empName',
    ellipsis: true,
  },
  {
    title: 'OCCUPATION',
    dataIndex: 'occupation',
    key: 'occupation',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'DATE OF JOINING',
    dataIndex: 'dateOfJoining',
    key: 'dateOfJoining',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'statusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
